module.exports = __webpack_public_path__ + "img/tu_schedule_match.f9ed2a75.svg";